import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import MoodleWriterForm from '../forms/moodle-writer-form';
import { moodleWriterValidationSchema } from '../schema/moodleWriter.js';

export default function MoodleWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Moodle Writer Node Details',
        altText: 'Moodle Writer Node',
        defaultLabel: 'Moodle Writer Node',
      }}
    >
      <CommonNode FormComponent={MoodleWriterForm} schemaResolver={moodleWriterValidationSchema} />
    </NodeProvider>
  );
}
